<template>
  <router-link to="/#projects">Ir a Projects</router-link>
</template>
<script>


export default {
  name: 'AboutPage',
  components: {

  },


}
</script>
